import React, { useEffect } from 'react';

import AuthenticationManager from "../services/StorageJWT";
import { Navigate } from 'react-router';

const AuthContext = React.createContext(null);

export const AuthProvider = ({ children }) => {
    const _auth = new AuthenticationManager();
 
 
    const handleLogin = async () => {
  
    //   setToken(token);
    };
  
    const handleLogout = () => {
    //   setToken(null);
    _auth.logout();
    };
  
    const value = {
      token:_auth._token,
      onLogin: handleLogin,
      onLogout: handleLogout,
    };
  
    return (
      <AuthContext.Provider value={value}>
        {children}
      </AuthContext.Provider>
    );
  };
  export const useAuth = () => {
    return React.useContext(AuthContext);
  };

  export const ProtectedRoute = ({ children }) => {
    const { token } = useAuth();
  
    if (!token) {
      return <Navigate to="/" replace />;
    }
  
    return children;
  };